import axios from 'axios';
import { toast } from 'react-toastify';
import ScrollToTop from 'helpers/scrollToTop';
import { getValue, purgeStorage } from 'utils/storage';

const httpClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

httpClient.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    return Promise.reject(error);
  },
);

httpClient.interceptors.request.use(function (config) {
  const token = getValue<string>({ prop: 'exeltis-api-token' });

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

httpClient.interceptors.response.use(
  function (response) {
    //ScrollToTop();
    return response;
  },
  function (error) {
    if (
      error.response &&
      (error.response.status === 500 || error.response.status === 400)
    ) {
      toast.error(
        'Algo deu errado ao carregar essa solicitação. Tente novamente.',
      );
      return Promise.reject(error);
    }

    if (error.response && error.response.status === 401) {
      purgeStorage({ prop: 'exeltis-api-token' });
      purgeStorage({ prop: 'exeltis-user' });
      window.location.href = window.location.origin + '/';
    } else {
      return Promise.reject(error);
    }
  },
);

export default httpClient;
